import axios from "./../axios";
import BenchMarkDetailsModal from "../pages/dani/BenchMarkDetailsModal";
export const TRIGGER_TYPE_FUNCTION = 1;
export const WELCOME_OPTIONS_ID = "4";

export const SELECT_CHART_MESSAGE = {
  id: "8",
  message: "Please select a chart first.",
  trigger: "7",
};

export const CHART_SELECTED_MESSAGE = {
  id: "9",
  message: "Great! What would you like to do with this chart?",
  trigger: "10",
  end: true,
};

export const TOOLKIT_SELECTED_STEP = {
  id: "16",
  message: "Could you please rate this tool?",
  trigger: "17",
};
export const SELECTED_CHART_OPTIONS = {
  id: "10",
  options: [
    {
      id: "sc1",
      label: "I want to drill down into the analytics.",
      trigger: "DRILLDOWN_CHART",
      isOption: true,
      triggerType: TRIGGER_TYPE_FUNCTION,
    },
    {
      id: "sc2",
      label: "Show me solutions and resources that may be  helpful.",
      trigger: "SHOW_SOLUTIONS",
      isOption: true,
    },
    // {
    //   id: "sc3",
    //   label: "Keep chatting",
    //   trigger: "15",
    //   isOption: true,
    // },
  ],
};

export const UPLOAD_PDF_CONFIRM = {
  id: "upload_pdf_confirm",
  options: [
    {
      id: "up-yes",
      label: "Yes please.",
      trigger: "35",
      isOption: true,
    },
    {
      id: "up-no",
      label: "No, Keep chatting.",
      trigger: "34",
      isOption: true,
    },
  ],
};

export const CUSTOM_UPLOAD_OPERATION_GOBACK = {
  id: "39",
  options: [
    {
      id: "gb1",
      label: "Go Back",
      trigger: "file_upload_dani_response",
      isOption: true,
    },
  ],
  trigger:"37"
};

export const UPLOAD_PDF_OPTIONS_AFTER_RESPONSE = {
  id: "file_upload_dani_response",
  message: "Great. Which of the following can I help you with?",
  options: [
    {
      id: "fo-1",
      label: "Change language to make more inclusive",
      trigger: "FETCH_SEARCH_RESULTS",
      isOption: true,
    },
    {
      id: "fo-2",
      label:
        "Evaluate the general sentiment and provide a list of actions to make more positive (positive/negative)",
      trigger: "FETCH_SEARCH_RESULTS",
      isOption: true,
    },
    {
      id: "fo-3",
      label: "List the key topics, possible discussion questions and provide a mind map",
      trigger: "FETCH_SEARCH_RESULTS",
      isOption: true,
    },
    {
      id: "fo-4",
      label: "Write your own question about the task",
      trigger: "37",
      isOption: true,
    },
    {
      id: "fo-5",
      label: "Keep chatting",
      trigger: "34",
      isOption: true,
    },
  ],
};

export const SELECT_KPI_MESSAGE = {
  id: "20",
  message: "Select the KPI you want to take action on.",
  trigger: "SELECT_KPI_FOR_CHART",
  end: true,
};

export const TAKE_AN_ACTION_OPTION = {
  id: "o2",
  label: "I want to take an action",
  stepType: "Analytics",
  trigger: "6",
  isOption: true,
};

export const TALK_WITH_ASSISTANT_OPTION = {
  id: "o14-ai",
  label: "Ask me a question",
  trigger: "14",
  apiValue: "talk",
  isOption: true,
};

export const PROVIDE_BENCHMARK = {
  id: "o32-ai",
  label: "Provide a Benchmark",
  trigger: "32",
  apiValue: "benchmark",
  isOption: true,
};

export const WAIT_ASSISTANT_RESPONSE = {
  id: "a-response",
  message: "Thank you for your responses. Let me see what I can find…",
};

const fetchRecommendedTools = chartId => {
  const client = axios.get(``);
  return client;
};

export const USEFUL_TOOLS_TEXT = {
  id: "11",
  message: "I think you may find these types of tools helpful.",
  trigger: "12",
};

export const welcomeStep = [
  {
    id: "1",
    message: "Hi _$USER_NAME$_ 👋! I’m _$DANI_NAME$_. How may I help you today?",
    //  trigger: "2",
    // trigger: WELCOME_OPTIONS_ID,'
    trigger: "15",
    clickModalComponent: "BenchMarkDetailsModal",
    end: true,
  },
  // {
  //   id: "2",
  //   message: `I’m Dani - your DEI assistant. I can help you with questions,
  //   and also actions to gain insights and find resources and solutions.`,
  //   trigger: "3",
  // },
  // {
  //   id: "3",
  //   message: "How can I help you today?",
  //   trigger: WELCOME_OPTIONS_ID,
  //   end: true,
  // },
  {
    id: WELCOME_OPTIONS_ID,
    options: [
      TAKE_AN_ACTION_OPTION,
      TALK_WITH_ASSISTANT_OPTION,
      PROVIDE_BENCHMARK,
    ],
  },
  { id: "6", message: "Got it. ", trigger: "7" },
  SELECT_CHART_MESSAGE,
  {
    id: "7",
    message:
      "Please click on the Engage button in top right corner of the chart that you want to engage with.",
    trigger: "",
    end: true,
  },
  CHART_SELECTED_MESSAGE,
  SELECTED_CHART_OPTIONS,
  USEFUL_TOOLS_TEXT,
  {
    id: "12",
    message: "Please select one.",
    trigger: "FETCH_RECOMMENDED_TOOLS",
    end: true,
    triggerType: TRIGGER_TYPE_FUNCTION,
  },
  {
    id: "13",
    message: "Please type your DEI-related question in a few words.",
    trigger: "15",
    end: true,
  },
  {
    id: "14",
    message: "What HR question do you have on your mind?",
    trigger: "15",
    apiValue: "talk",
    end: true,
  },
  { id: "15", showInput: true, trigger: "", apiValue: "talk" },
  {
    id: "16",
    options: [
      {
        id: "o3",
        label: "Show me more answers.",
        trigger: "FETCH_MORE_RESULTS",
        isOption: true,
      },
      {
        id: "o4",
        label: "I want to ask another question.",
        trigger: "13",
        isOption: true,
      },
      {
        id: "o4",
        label: "I am done for now.",
        trigger: "CLOSE_DANI",
        isOption: true,
      },
    ],
  },
  TOOLKIT_SELECTED_STEP,
  {
    id: "17",
    message:
      "Ratings help me learn faster and make better future recommendations to you. Thank you! 🙏",
    trigger: "",
    end: true,
  },
  // {id:'18',message:'Unless you have a question, you can close this chat. I look forward to chatting again soon! ⭐',
  //   trigger:'19',end:true},
  // {id:'19',options:[{id:'op3',label:'I have a question',trigger:'13',isOption:true}]},
  SELECT_KPI_MESSAGE,
  {
    id: "21",
    message: "I think you may find these types of tools helpful.",
    trigger: "22",
  },
  {
    id: "22",
    message: "Please select one.",
    trigger: "KPI_FOR_CHART_SELECTED",
    end: true,
  },
  {
    id: "32",
    message: `What kind of benchmark are you looking for? I can provide you with benchmarks for everything from representation to compensation to best in class policies.
    To find out more about how to ask me about various benchmarks, `,
    trigger: "33",
    apiValue: "benchmark",
    end: true,
    clickModalComponent: `BenchMarkDetailsModal`,
  },
  { id: "33", showInput: true, trigger: "", apiValue: "benchmark" },
  UPLOAD_PDF_OPTIONS_AFTER_RESPONSE,
  { id: "34", message: "Great. Let’s keep chatting", trigger: "15" },
  {
    id: "35",
    message: "Great. Which of the following can I help you with?",
    trigger: "file_upload_dani_response",
  },
  {
    id: "36",
    message:
      "Anything else I can help you with on this document? If not, just select keep chatting 😊",
    trigger: "file_upload_dani_response",
  },
  { id: "37", showInput: true, trigger: "", apiValue: "talk",isPdfExtract:true },
  {
    id: "38",
    message: "Great. Please provide me with an action or task to do with respect to this file or select Go Back below",
    trigger: "39",
  },
  CUSTOM_UPLOAD_OPERATION_GOBACK
];

export const isOnChartList = path => {
  return path.contains("analytics");
};

export const toolkitRecommender = [
  {
    name: "Women compensation",
    code: "COMP-1",
    toolkits: [
      {
        name: "Best Practices > Compensation",
        url: "/home/toolkit/best-practices",
        subcategory: "Compensation",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : ""
      // },
      {
        name: "Policies & Benefits > Compensation",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Compensation",
      },
    ],
  },
  {
    name: "New Hire Compensation",
    code: "COMP-2",
    toolkits: [
      {
        name: "Best Practices > Compensation",
        url: "/home/toolkit/best-practices",
        subcategory: "Compensation",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Policies & Benefits > Compensation",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Compensation",
      },
    ],
  },
  {
    name: "Employee Compa-Ratio",
    code: "COMP-3",
    toolkits: [
      {
        name: "Best Practices > Compensation",
        url: "/home/toolkit/best-practices",
        subcategory: "Compensation",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : "Recruiters"
      // },
      {
        name: "Policies & Benefits > Compensation",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Compensation",
      },
    ],
  },
  {
    name: "Promotion",
    code: "GRO-1",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Employee Growth",
    code: "GRO-2",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Outstanding Performance",
    code: "GRO-3",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Solid Performance",
    code: "GRO-4",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Poor Performance",
    code: "GRO-5",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
      {
        name: "Policies & Benefits > Growth & Performance",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Growth & Performance",
      },
    ],
  },
  {
    name: "Sponsorship",
    code: "GRO-6",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Best Practices > Processes & Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes & Policies",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : ""
      // }
    ],
  },
  {
    name: "Mentorship",
    code: "GRO-7",
    toolkits: [
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : ""
      // }
    ],
  },
  {
    name: "Ready-now Executive Succession",
    code: "GRO-8",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Future Executive Succession",
    code: "GRO-9",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Ready-now Management Succession",
    code: "GRO-10",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Future Management Succession",
    code: "GRO-11",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
    ],
  },
  {
    name: "Applicant Pool",
    code: "HRT-1",
    toolkits: [
      {
        name: "Recruitment & Hiring > Job Boards",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Job Boards",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Workplace Culture > Comunications",
        url: "/home/toolkit/workplace-culture",
        subcategory: "Comunications",
      },
    ],
  },
  {
    name: "Interview Slate",
    code: "HRT-2",
    toolkits: [
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
    ],
  },
  {
    name: "Interviewers",
    code: "HRT-3",
    toolkits: [
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      {
        name: "Training & Development > Hiring & Retention",
        url: "/home/toolkit/training-development",
        subcategory: "Hiring & Retention",
      },
    ],
  },
  {
    name: "Job offers",
    code: "HRT-4",
    toolkits: [
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      {
        name: "Training & Development > Hiring & Retention",
        url: "/home/toolkit/training-development",
        subcategory: "Hiring & Retention",
      },
    ],
  },
  {
    name: "Hirees",
    code: "HRT-5",
    toolkits: [
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      {
        name: "Workplace Culture > Benefits",
        url: "/home/toolkit/workplace-culture",
        subcategory: "Benefits",
      },
    ],
  },
  {
    name: "Voluntary Separation",
    code: "HRT-6",
    toolkits: [
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Employee Groups",
        url: "/home/toolkit/ergs",
        subcategory: "",
      },
      {
        name: "Policies & Benefits > Hiring & Retention",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Hiring & Retention",
      },
    ],
  },
  {
    name: "Involuntary Separation",
    code: "HRT-7",
    toolkits: [
      {
        name: "Best Practices > Growth & Performance",
        url: "/home/toolkit/best-practices",
        subcategory: "Growth & Performance",
      },
      {
        name: "Policies & Benefits > Talent Management",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Talent Management",
      },
    ],
  },
  {
    name: "Opt-Out",
    code: "HRT-8",
    toolkits: [
      {
        name: "Workplace Culture > Benefits",
        url: "/home/toolkit/workplace-culture",
        subcategory: "Benefits",
      },
      {
        name: "Policies & Benefits > Hiring & Retention",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
    ],
  },
  {
    name: "Strategy",
    code: "PRP-1",
    toolkits: [
      {
        name: "Best Practices > Processes and Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes and Policies",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : ""
      // }
    ],
  },
  {
    name: "Infrastructure",
    code: "PRP-2",
    toolkits: [
      {
        name: "Best Practices > Processes and Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes and Policies",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : ""
      // }
    ],
  },
  {
    name: "Accountability",
    code: "PRP-3",
    toolkits: [
      {
        name: "Best Practices > Processes and Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes and Policies",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
      // {
      //   name : "Consultants",
      //   url : "/home/toolkit/consultants",
      //   subcategory : ""
      // }
    ],
  },
  {
    name: "Training & Development",
    code: "PRP-4",
    toolkits: [
      {
        name: "Training & Development > Workshops & Classes",
        url: "/home/toolkit/training-development",
        subcategory: "Workshops & Classes",
      },
      {
        name: "Training & Development > Mentors & Coaches",
        url: "/home/toolkit/training-development",
        subcategory: "Mentors & Coaches",
      },
      {
        name: "Best Practices > Training & Development",
        url: "/home/toolkit/best-practices",
        subcategory: "",
      },
    ],
  },
  {
    name: "Parental Leave",
    code: "PRP-5",
    toolkits: [
      {
        name: "Policies & Benefits > Family Support",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Family Support",
      },
      {
        name: "Policies & Benefits > Workplace Flexibility",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Flexibility",
      },
      {
        name: "Best Practices > Processes & Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes & Policies",
      },
    ],
  },
  {
    name: "Family/Elder Care",
    code: "PRP-6",
    toolkits: [
      {
        name: "Policies & Benefits > Family Support",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Family Support",
      },
      {
        name: "Policies & Benefits > Workplace Flexibility",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Flexibility",
      },
      {
        name: "Best Practices > Processes & Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes & Policies",
      },
    ],
  },
  {
    name: "Work Flexibility",
    code: "PRP-7",
    toolkits: [
      {
        name: "Best Practices > Processes & Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes & Policies",
      },
      {
        name: "Policies & Benefits > Work Flexibility",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Work Flexibility",
      },
      {
        name: "Workplace Culture > Benefits",
        url: "/home/toolkit/communications",
        subcategory: "Benefits",
      },
    ],
  },
  {
    name: "Sexual Harassment",
    code: "PRP-8",
    toolkits: [
      {
        name: "Best Practices > Processes & Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes & Policies",
      },
      {
        name: "Policies & Benefits > Sexual Harassment",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Sexual Harassment",
      },
    ],
  },
  {
    name: "Leadership Diversity",
    code: "PRP-9",
    toolkits: [
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Policies & Benefits > Talent Management",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Talent Management",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
    ],
  },
  {
    name: "Recruiting Diversity",
    code: "PRP-10",
    toolkits: [
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Recruitment & Hiring > Job Boards",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Job Boards",
      },
    ],
  },
  {
    name: "Advocacy",
    code: "PRP-11",
    toolkits: [
      {
        name: "Best Practices > Processes & Policies",
        url: "/home/toolkit/best-practices",
        subcategory: "Processes & Policies",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
    ],
  },
  {
    name: "Communications and Support",
    code: "PRP-12",
    toolkits: [
      {
        name: "Employee Groups",
        url: "/home/toolkit/ergs",
        subcategory: "",
      },
    ],
  },
  {
    name: "Representation",
    code: "REP-1",
    toolkits: [
      {
        name: "Recruitment & Hiring > Job Boards",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Job Boards",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
    ],
  },
  {
    name: "Board Makeup",
    code: "REP-2",
    toolkits: [
      {
        name: "Best Practices > Hiring & Retention",
        url: "/home/toolkit/best-practices",
        subcategory: "Hiring & Retention",
      },
      {
        name: "Recruitment & Hiring > Recruiters",
        url: "/home/toolkit/recruitment-hiring",
        subcategory: "Recruiters",
      },
      {
        name: "Policies & Benefits > Workplace Diversity and Inclusion",
        url: "/home/toolkit/policies-benefits",
        subcategory: "Workplace Diversity and Inclusion",
      },
    ],
  },
  {
    name: "EBIT Margin",
    code: "B&C-1",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Revenue Growth",
    code: "B&C-2",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "ROIC",
    code: "B&C-3",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Mission Alignment",
    code: "B&C-4",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Employee Engagement",
    code: "B&C-5",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Employee Dedication",
    code: "B&C-6",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Employee Endorsement",
    code: "B&C-7",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Employee Loyalty",
    code: "B&C-8",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
  {
    name: "Employee Commitment",
    code: "B&C-9",
    toolkits: [
      {
        name: "Best Practices > Business & Culture",
        url: "/home/toolkit/best-practices",
        subcategory: "Business & Culture",
      },
    ],
  },
];
